
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width:'100%',
        backgroundImage:
            "url(" +
            require("../../assets/img/brand/header.jpg").default +
            ")",
        }}>
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
            
              
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
